import styled from "styled-components";

// Glass card on the indigo header — matches the role pill's translucent look.
export const PlanStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 214px;
  padding: 9px 13px;
  border-radius: ${({ theme }) => theme.radius[12]};
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  cursor: pointer;
  transition: background 0.14s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
  }

  .check {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: ${({ theme }) => theme.colors.success[500]};
    box-shadow: 0 0 0 3px rgba(75, 181, 67, 0.22);
  }

  .body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .label {
    font-weight: 600;
    font-size: 10.5px;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.6);
  }

  .title {
    margin: 1px 0 0;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: -0.2px;
    color: #fff;
  }

  .meta {
    margin: 2px 0 0;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.72);
  }

  .manageHint {
    margin: 0 0 0 auto;
    align-self: flex-start;
    flex-shrink: 0;
    font-weight: 600;
    font-size: 12.5px;
    color: #fff;
    opacity: 0.8;
    text-decoration: underline;
  }

  &:hover .manageHint {
    opacity: 1;
  }
`;
